import { cn } from '~/lib/utils';
import type { MatchResult } from '~/types/pipeline';

const HIGH_CONFIDENCE = 0.6;

export function MatchConfidenceBadge({ match }: { match: MatchResult }) {
  const ok = match.confidence >= HIGH_CONFIDENCE;
  const percent = Math.round(match.confidence * 100);
  return (
    <div
      className={cn(
        'pointer-events-none absolute right-1 top-1 min-w-8 rounded border px-1 py-0.5 text-center text-[10px] font-semibold leading-none tabular-nums text-white shadow-sm ring-1 ring-black/35',
        ok ? 'border-emerald-200/70 bg-emerald-600/95' : 'border-rose-200/70 bg-rose-600/95',
      )}
      title={`Match confidence ${(match.confidence * 100).toFixed(0)}%`}
    >
      {percent}%
    </div>
  );
}
